import React, { FC } from "react";

import {
  useApisMembersKnowledgeInsightPostsLikedEmployeesIndex,
  useArray,
} from "~/hooks";

import { ReactedEmployeeType } from "~/domains";

import { ReactedEmployeesModal } from "~/ui";

type PropsType = {
  knowledgeInsightPostId: string;
  onClose: () => void;
};

export const KnowledgeInsightPostsLikedEmployeesModal: FC<PropsType> = ({
  knowledgeInsightPostId,
  onClose,
}: PropsType) => {
  const { items, setItems } = useArray<ReactedEmployeeType>([]);
  const { fetchNextPage, hasNextPage, isLoading } =
    useApisMembersKnowledgeInsightPostsLikedEmployeesIndex({
      knowledgeInsightPostId,
      config: {
        onSuccess: (data) => {
          setItems(
            data.pages.map((page) => page.knowledgeInsightPostLikes).flat(),
          );
        },
      },
    });
  return (
    <ReactedEmployeesModal
      headerTitle="いいねしたユーザー"
      onClose={onClose}
      reactedEmployees={items}
      nextFetchFunction={fetchNextPage}
      hasMore={hasNextPage}
      isLoading={isLoading}
    />
  );
};
